<template>
  <div class="selectEnv">
    <v-select
      ref="selectEnv"
      label="API Environment"
      :items="envs"
      :value="env"
      @change="changeEnv"
    />
  </div>
</template>

<script>

import apiEnv from '@/enum/apiEnv';

export default {
  name: 'EnvSelect',

  computed: {
    env() { return localStorage.getItem('Exporo.API.env'); },
    envs() {
      return Object.keys(apiEnv).map(env => ({
        text: apiEnv[env].title,
        value: env,
      }));
    },
  },
  methods: {
    async changeEnv(env) {
      localStorage.setItem('Exporo.API.env', env);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.selectEnv {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/EnvSelect.vue